/**
 * localStorage keys for Electron (and Capacitor) shells, plus helpers shared with main-process persistence.
 * Packaged Electron uses a loopback URL; port stability + userData JSON backup avoids losing state when the port changes.
 */

/** Tenant subdomain for API base URL (same key historically used for Capacitor). */
export const LS_CAPACITOR_SUBDOMAIN = 'capacitor_api_subdomain'

export const LS_CFD_ENABLED = 'equipment.customerDisplay.enabled'
export const LS_CFD_HARDWARE_MODE = 'equipment.customerDisplay.hardwareMode'

export function normalizeShellSubdomain (value) {
  return String(value ?? '').trim().toLowerCase()
}

export function isValidShellSubdomain (value) {
  return /^[a-z0-9-]+$/.test(String(value || ''))
}
